import { BlacklistUserInfoGeneralTypes } from './types';
import BlacklistUserInfoGeneralBlock from './user-info-general-block';
import { pepColumns, sactionsColumns } from './variables/risk-segment';

import cn from './blacklist.module.css';

const BlacklistUserInfoRiskSegments = ({
  info,
}: BlacklistUserInfoGeneralTypes) => (
  <div className={cn.userInfoContent}>
    <div className={cn.userInfoContentBlock}>
      <div className={`${cn.userInfoGeneralTitle} ${cn.withMargin}`}>
        {`Adverse Media (${
          info?.source?.entitySegments?.entityAdverseMedias?.length || 0
        })`}
      </div>
      {(!info?.source?.entitySegments?.entityAdverseMedias ||
        !info?.source?.entitySegments?.entityAdverseMedias?.length) && (
        <div className={cn.userInfoRiskItem}>
          <div className={cn.userInfoRiskItemLeft}>—</div>
        </div>
      )}
      {info?.source?.entitySegments?.entityAdverseMedias &&
        info?.source?.entitySegments?.entityAdverseMedias?.length > 0 &&
        info?.source?.entitySegments?.entityAdverseMedias?.map((item) => (
          <div
            className={cn.userInfoRiskItem}
            key={item.entityAdverseMediaGUID}
          >
            <div className={cn.userInfoRiskItemLeft}>
              <div className={cn.userInfoRiskItemLeftValue}>
                {item?.adverseMediaDesc || '—'}
              </div>
              <div className={cn.userInfoRiskItemLeftValue}>
                {item?.subCategories || '—'}
              </div>
            </div>
            <div
              className={cn.userInfoRiskItemRight}
            >{`(${item.lastUpdated})`}</div>
          </div>
        ))}
    </div>
    <div className={cn.userInfoContentBlock}>
      <div className={`${cn.userInfoGeneralTitle} ${cn.withMargin}`}>
        {`Enforcement (${
          info?.source?.entitySegments?.entityEnforcements?.length || 0
        })`}
      </div>
      {(!info?.source?.entitySegments?.entityEnforcements ||
        !info?.source?.entitySegments?.entityEnforcements?.length) && (
        <div className={cn.userInfoRiskItem}>
          <div className={cn.userInfoRiskItemLeft}>—</div>
        </div>
      )}
      {info?.source?.entitySegments?.entityEnforcements &&
        info?.source?.entitySegments?.entityEnforcements?.length > 0 &&
        info?.source?.entitySegments?.entityEnforcements?.map((item) => (
          <div className={cn.userInfoRiskItem} key={item.entityEnforcementGUID}>
            <div className={cn.userInfoRiskItemLeft}>
              <div className={cn.userInfoRiskItemLeftValue}>
                {item?.enforcementDesc
                  ? `${item?.enforcementDesc} ${
                      item.administrativeUnitName
                        ? `(${item.administrativeUnitName})`
                        : ''
                    }`
                  : '—'}
              </div>
              {item.sourceName && (
                <div className={cn.userInfoRiskItemLeftValue}>
                  {`Source: ${item.sourceName}`}
                </div>
              )}
              <div className={cn.userInfoRiskItemLeftValue}>
                {item?.subCategories || '—'}
              </div>
            </div>
            <div
              className={cn.userInfoRiskItemRight}
            >{`(${item.lastUpdated})`}</div>
          </div>
        ))}
    </div>
    <div className={cn.userInfoContentBlock}>
      <BlacklistUserInfoGeneralBlock
        info={info?.source?.entitySegments?.entityPEPs}
        columns={pepColumns}
        title={`PEP (${info?.source?.entitySegments?.entityPEPs?.length || 0})`}
      />
    </div>
    <div className={cn.userInfoContentBlock}>
      <BlacklistUserInfoGeneralBlock
        info={info?.source?.entitySegments?.entitySanctions}
        columns={sactionsColumns}
        title={`Sanctions (${
          info?.source?.entitySegments?.entitySanctions?.length || 0
        })`}
      />
    </div>
  </div>
);

export default BlacklistUserInfoRiskSegments;
